import React from 'react'
import { CFSelect, CFView, DefaultScreen, MobileScreen } from 'components'
import { isEmpty } from 'lodash'
import { moment, formatWeeklyHours } from 'cf-utils'
import { dispatch } from 'store'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h2
          futura
          bold
          color="rgb(149, 123, 96)"
          pb="20px"
          column
          center
        >
          BUSINESS HOURS
        </CFView>
        <CFView maxWidth="250px">
          <CFSelect selector={dispatch.restaurant.getHours}>
            {hours =>
              [1, 2, 3, 4, 5, 6, 0].map(day => (
                <>
                  <CFView key={day} column>
                    <CFView row w="100%" mb="10px">
                      <CFView w="80px">
                        <CFView h4 white bold>{`${moment()
                          .weekday(day)
                          .format('ddd')}`}</CFView>
                      </CFView>
                      <CFView h4 white bold w="100%" row justifyEnd textRight>
                        {isEmpty(hours) ? '' : formatWeeklyHours(hours[day], dispatch.restaurant.getSelectedLocation()?.timeZone, ' ')}
                      </CFView>
                    </CFView>
                  </CFView>
                </>
              ))
            }
          </CFSelect>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView h2 futura bold color="rgb(149, 123, 96)" pb="20px">
          BUSINESS HOURS
        </CFView>
        <CFSelect selector={dispatch.restaurant.getHours}>
          {hours =>
            [1, 2, 3, 4, 5, 6, 0].map(day => (
              <>
                <CFView key={day}>
                  <CFView row w="100%" mb="10px">
                    <CFView w="80px">
                      <CFView h4 white bold>{`${moment()
                        .weekday(day)
                        .format('ddd')}`}</CFView>
                    </CFView>
                    <CFView h4 white bold>
                      {isEmpty(hours) ? '' : formatWeeklyHours(hours[day], dispatch.restaurant.getSelectedLocation()?.timeZone)}
                    </CFView>
                  </CFView>
                </CFView>
              </>
            ))
          }
        </CFSelect>
      </DefaultScreen>
    </CFView>
  )
}
